/**
 * Converts a 2-letter ISO 3166-1 country code to its Unicode flag emoji
 * (regional indicator symbols), e.g. 'BE' -> 🇧🇪.
 * @param {string} isoCode
 * @returns {string}
 */
function isoCodeToFlagEmoji(isoCode) {
  return String.fromCodePoint(
    ...isoCode
      .toUpperCase()
      .split('')
      .map((char) => 127397 + char.charCodeAt(0)),
  );
}

export class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
    };

    this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  connectedCallback() {
    this.renderFlags();
  }

  /**
   * `component-country-flag.liquid` already renders a real SVG for every supported
   * market — this only fills the gap for a market that snippet doesn't cover yet, so
   * a newly-enabled market still shows *something* rather than nothing. The emoji's
   * appearance depends on the OS/browser having a colour flag font, which is exactly
   * the inconsistency this SVG-first approach exists to avoid (QI TSK-80356) — so this
   * is a deliberately lower-fidelity fallback, not the primary path.
   */
  renderFlags() {
    for (const el of this.querySelectorAll('[data-country-code]')) {
      const flag = el.querySelector('.localization-flag');
      if (!flag || flag.childElementCount > 0) {
        continue;
      }

      flag.textContent = isoCodeToFlagEmoji(el.dataset.countryCode);
    }
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) {
      form.submit();
    }
  }
}

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}
